export default "__VITE_ASSET__3369b177__"